import { Components, Theme } from '../../material';

export const MuiButton: Components<Theme>['MuiButton'] = {
  variants: [
    {
      props: { variant: 'contained' },
      style: {
        boxShadow: 'none',
        ':hover': { boxShadow: 'none' },
      },
    },
    {
      props: {
        size: 'small',
      },
      style: ({ theme }) => ({
        fontSize: theme.typography.pxToRem(12),
        fontWeight: theme.typography.fontWeightMedium,
        lineHeight: 1.3334,
        letterSpacing: 0,
        padding: '4px 12px',
      }),
    },
    {
      props: {
        size: 'small',
        variant: 'contained',
      },
      style: {
        padding: '5px 12px',
      },
    },
    {
      props: {
        size: 'medium',
      },
      style: ({ theme }) => ({
        fontSize: theme.typography.pxToRem(14),
        fontWeight: theme.typography.fontWeightMedium,
        lineHeight: 1.429,
        letterSpacing: 0,
        padding: '8px 16px',
      }),
    },
    {
      props: {
        size: 'medium',
        variant: 'contained',
      },
      style: {
        padding: '9px 16px',
      },
    },
    {
      props: {
        size: 'large',
      },
      style: ({ theme }) => ({
        fontSize: theme.typography.pxToRem(16),
        fontWeight: theme.typography.fontWeightMedium,
        lineHeight: 1.5,
        letterSpacing: 0,
        padding: '12px 24px',
      }),
    },
    {
      props: {
        size: 'large',
        variant: 'contained',
      },
      style: {
        padding: '13px 24px',
      },
    },
  ],
};
